module.exports = __webpack_public_path__ + "img/home_logo.47355218.svg";